// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TF5b","questions":"styles_questions__YxBbp","footer":"styles_footer__1WjOd"};